import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import {number_format,number_input_format} from '../helper/format';
import $ from 'jquery';

export default class TogetherProductpopup extends Component {
    constructor(props)
    {
        super(props);
        this.state = {
            open: false,
            isThirdOk: true
        };
    }
    Open(isThirdOk)
    {
        this.setState({
            open: true,
            isThirdOk: isThirdOk           
        });
    }
    Close()
    {
        this.setState({
            open: false           
        });
    }
    Apply(index)
    {
        if( index == 3 && !this.state.isThirdOk) 
        {
            alert('선택하실 수 없는 상품 입니다');
            return false;
        }
        this.props.onProductChanged(index);
        this.Close();
    }
    render()
    {
        const self = this;
        return (
            <Modal open={this.state.open} onClose={()=>{self.Close()}} center>
                <div className="modal-dialog modal-sm mb0">
                    <div className="popupPadding3">
                        <div className="md-popup-header"> &nbsp;유무선 결합 상품</div>
                        <div className="md-popup-contents pt0 pl0">
                            <table className="table priceTable">
                                <tbody>
                                    <tr key={0} onClick={()=>{self.Apply(0)}}>
                                        <td>미적용</td>
                                    </tr>
                                    <tr key={1} onClick={()=>{self.Apply(1)}}>
                                        <td>온가족플랜</td>
                                    </tr>
                                    <tr key={2} onClick={()=>{self.Apply(2)}}>
                                        <td>온가족프리</td>
                                    </tr>
                                    <tr key={3} onClick={()=>{self.Apply(3)}}>
                                        <td>한가족할인</td>
                                    </tr>
                                    <tr key={4} onClick={()=>{self.Apply(4)}}>
                                        <td>온가족할인</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}